import React, { useContext } from 'react'
import Sidebar from "../Sidebar/Sidebar";
import TokenHeader from "../TokenHeader/TokenHeader";
import TokenCheckoutpage from "../TokenCheckoutPage/TokenCheckoutPage";
import DashboardHeader from "../DashboardHeader/DashboardHeader";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useState, useEffect, useRef } from 'react';
import PurchaseHistory from '../PurchaseHistory/PurchaseHistory';
import AddNewCard from '../../Components/AddNewCard/AddNewCard.jsx'
import ArrowIcon from "../../Assets/Images/ArrowIcon .svg";
import Notification from '../Dashboard/Notification/Notification';
import { useNavigate, useLocation } from 'react-router-dom';
import { TokenContext } from '../../Context/TokenContext';

const TokenCheckout = () => {
	const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY}`);
	const notificationRef = useRef(null)
	const navigate = useNavigate();
	const location = useLocation();
	const tokenCtx = useContext(TokenContext)
	const totalTokens = location.state?.totalTokens || 0;

	const params = new URLSearchParams(location.search)
	const clientId = params.get("clientId")

	const [activeTab, setActiveTab] = useState("Buy Tokens");
	const [isNotificationOpen, setIsNotificationOpen] = useState(false);

	useEffect(() => {
		const handleOutsideClick = (event) => {
			if (notificationRef.current && !notificationRef.current.contains(event.target)) {
				setIsNotificationOpen(false);
			}
		};

		if (isNotificationOpen) {
			document.addEventListener('mousedown', handleOutsideClick);
		}

		return () => {
			document.removeEventListener('mousedown', handleOutsideClick);
		};
	}, [isNotificationOpen]);

	useEffect(() => {
		console.log("tokenCtx", tokenCtx?.tokenCount)
	}, [tokenCtx?.tokenCount])



	const handleNotificationOpen = () => {
		setIsNotificationOpen(true);
	}
	const handleNotificationClose = () => {
		setIsNotificationOpen(false);
	};

	const heading = (
		<>
			<span style={{ cursor: "pointer" }} onClick={() => { navigate(`/tokens?isBack=${true}`) }}>Tokens</span> <img src={ArrowIcon} alt="Arrow Icon" className="breadcrumb-arrow" /> Checkout
		</>
	);

	return (
		<div className="dashboard-platform">
			{/* <TokenHeader /> */}
			<DashboardHeader heading='Tokens' handleNotificationOpen={handleNotificationOpen} />
			<Notification ref={notificationRef} handleNotificationClose={handleNotificationClose} isNotificationOpen={isNotificationOpen} />
			<div className="dashboard-container">
			<div className="token-tabs">
				<div className={`tab ${activeTab === "Buy Tokens" ? "active" : ""}`} onClick={() => setActiveTab("Buy Tokens")} >Buy Tokens</div>
				<div className={`tab ${activeTab === "Purchase History" ? "active" : ""}`} onClick={() => setActiveTab("Purchase History")} >Purchase History</div>
				<div className={`tab ${activeTab === "Payment Method" ? "active" : ""}`} onClick={() => setActiveTab("Payment Method")} >Payment Method</div>
			</div>
				{activeTab === "Buy Tokens" && (
					<div className="inner-container">
						<Elements stripe={stripePromise}>
							<TokenCheckoutpage heading={heading} clientId={clientId} tokensFromNewCard={totalTokens} />
						</Elements>
						<div className="bottom-anchor"></div>
					</div>
				)}
				{activeTab === "Purchase History" && <PurchaseHistory />}
				{activeTab === "Payment Method" && <AddNewCard />}
			</div>
		</div>
	)
}

export default TokenCheckout;